import { render, staticRenderFns } from "./MenuStorage.vue?vue&type=template&id=e5d47496&scoped=true&"
import script from "./MenuStorage.vue?vue&type=script&lang=js&"
export * from "./MenuStorage.vue?vue&type=script&lang=js&"
import style0 from "./MenuStorage.vue?vue&type=style&index=0&id=e5d47496&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d47496",
  null
  
)

export default component.exports